import {
  EventBus,
  USER_PERMISSIONS_REFRESHED,
} from "Public/store/modules/eventbus";

export const PERMISSIONS_SET = "permissions/set";
export const PERMISSIONS_GET = "permissions/get";
export const PERMISSIONS_CHECK = "permissions/check";
export const PERMISSIONS_REFRESH = "permissions/refresh";

const state = {
  permissions: [],
};

const getters = {
  [PERMISSIONS_GET]: ({ permissions }) => {
    return permissions;
  },
  [PERMISSIONS_CHECK]: ({ permissions }, permission) => {
    return permissions.includes(permission);
  },
};

const actions = {
  [PERMISSIONS_REFRESH]: ({ commit }) => {
    return axios.get("/api/init").then(({ data }) => {
      commit(PERMISSIONS_SET, data.permissions);
      EventBus.$emit(USER_PERMISSIONS_REFRESHED);
    });
  },
};

const mutations = {
  [PERMISSIONS_SET]: (state, permissions) => {
    state.permissions = [...permissions];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
